import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Quiz from '@/pages/Quiz'
import Results from '@/pages/Results'
import Privacy from '@/pages/Privacy'
import { useRoutes } from 'react-router-dom'

export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/quiz', element: <Quiz /> },
  { path: '/results', element: <Results /> },
  { path: '/privacy', element: <Privacy /> },
]

function App() {
  return useRoutes(routes)
}

export default App
